import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';
import { allCourses } from '../../data/all-coursers';
import { CourseStatus } from '../../interfaces/course-status';
import { ComplexityLevelComponent } from './components/complexity-level/complexity-level.component';
import { ReplaceWhitespaceWithHyphenPipe } from '../../../../core/replace-whitespace-with-hyphen/pipes/replace-whitespace-with-hyphen.pipe';
import { RouterLink } from '@angular/router';

const courses = allCourses
  .filter(
    (course) =>
      course.status === CourseStatus.Ready ||
      course.status === CourseStatus.WaitingList,
  )
  .sort((a, b) => b.releaseDate.getTime() - a.releaseDate.getTime());

@Component({
  selector: 'app-courses-section',
  imports: [
    ContentContainer,
    ComplexityLevelComponent,
    RouterLink,
    ReplaceWhitespaceWithHyphenPipe,
  ],
  templateUrl: './courses-section.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoursesSection {
  courses = signal(courses);
}
